import { CategoryDto } from '../../../../../core/dto/categories/categorydto';
import * as React from 'react';
import { MultiselectCategoryListViewModelImpl } from '../../../login/createaccountcomponent/categorylist/viewmodel/multiselectcategorylistviewmodel';
import { PreferenceCategoryCardComponent } from './preferencecategorycardcomponent';


export class PreferenceCategoryListViewModelImpl extends MultiselectCategoryListViewModelImpl
{
    getView(t: CategoryDto, position: number): boolean | JSX.Element 
    {
        return <PreferenceCategoryCardComponent isSelected={this.isCategoriesSelected(t.getId())} isEditable={this.getIsEditable()} key={position} onSelected={this.onCategorySelected} context={this.getContext()} categoryDto={t}  position={position}/>;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferenccard/preferencecategorylistviewmodel.tsx